/* eslint-disable react-hooks/exhaustive-deps */


import { useDataStore } from "src/modules/pe-basic-module/data/store";
import { useEffect, useState } from "react";
import { INVITE_TYPE } from "src/libs/interfaces/layouts";
import LogsForm from "src/modules/pe-admin-module/views/logs/LogsForm";
import useLand from "src/modules/pe-basic-module/hooks/useLand";
import { ILand } from "src/modules/pe-fest-module/data/interfaces";
import EventTypeForm from "src/modules/pe-fest-module/views/festAdmin/EventTypeForm";
import { IToposStore, useToposStore } from "../data/store";
import DateSelect from "../views/admin/DateSelect";
import InheritanceForm from "../views/admin/InheritanceForm";


export function useAdminRoutes( ) {  
    const lands:ILand[] = useDataStore((state: any) => state.Land || [])
    const land = useLand()
    const eventTypeAdminData: any = useToposStore((state: IToposStore) => state.eventTypeAdminData )
    const eventTypes = land.event_types
    const [data, setData] = useState<any>({})
    useEffect(() => {
        let addedData: any = {}
        Object.keys(eventTypeAdminData)
            .filter( key => { 
                return eventTypes?.includes(key)
            })
            .forEach( key => { 
                if(!!eventTypeAdminData[key]) {
                    addedData = {...addedData, ...eventTypeAdminData[key]}
                }
            }) 
        // console.log(eventTypes, land)
        const data: any =  {
            eventTypes : { 
                title: "Events setting",
                group: "Events setting",
                component: EventTypeForm,
                position: "left", 
                icon: <i className="fas fa-calendar-alt"></i>, 
                rightMenuWidget:  <div className="d-flex" ><DateSelect field="startDate" /><DateSelect  field="finishDate"/></div> 
            },
            // communications : {
            //     title: "Communications",
            //     group: "Events setting",
            //     component: CommunicationsForm,
            //     position: "left"
            // },
            partners :  {
                title: "Partners",
                data_type: "PEToposPartner",
                group: "Events setting",
                position: "left", 
            }, 
            abbyss : {
                title: "Abyss utilities",
                group: "Events setting",
                component: InheritanceForm,
                position: "right"
            },
            media : {
                title: "Media library",
                group: "Events setting", 
                data_type: "Media",
                //component: MediaListForm,
                position: "right"
            },
            logs : {
                title: "Logs",
                group: "Events setting", 
                component: LogsForm,
                position: "right"
            },
            notifications : {
                title: "Notifications", 
                group: "Events setting", 
                undergroup: "Messages",
                data_type: "PENotification",
                position: "left", 
                icon: <i className="far fa-sticky-note"></i>, 
            },
            messages : {
                title: "User messages", 
                group: "Events setting", 
                undergroup: "Messages",
                data_type: "PEMessage",
                position: "left", 
                icon: <i className="fas fa-envelope"></i>, 
            },
            ads : {
                title: "Ads", 
                group: "Events setting", 
                undergroup: "Messages",
                data_type: "Ad",
                position: "left", 
                icon: <i className="fas fa-envelope"></i>, 
            },
            diaries : {
                title: "Diaries", 
                group: "Events setting",
                undergroup: "Messages",  
                data_type: "PEDiary",
                position: "left", 
                icon: <i className="fas fa-envelope"></i>, 
            },
            attachments : {
                title: "Attachments", 
                group: "Events setting", 
                undergroup: "Messages",
                data_type: "PEAttachment",
                position: "left", 
                icon: <i className="fas fa-paperclip"></i>, 
            },
            comments : {
                title: "Comments", 
                group: "Events setting", 
                undergroup: "Messages",
                data_type: "Comment",
                position: "left", 
                icon: <i className="fas fa-comment"></i>, 
            },
            cats : {
                title: "Categories", 
                group: "Events setting",
                data_type: "Category",
                position: "left", 
                icon: <i className="fas fa-comment"></i>, 
            },
            accounts :  {
                title: "Users accounts",
                data_type: "User",
                group: "Events setting",
                undergroup: "Users management",
                position: "left",
                icon: <i className="fas fa-user-friends"></i> 
            },
            start_date: {
                title: "Start date",
                group: "Events setting", 
                position: "head",
                icon: <i className="fas fa-clock"></i>, 
                component: DateSelect
            },
            finish_date: {
                title: "Finish date",
                group: "Events setting", 
                position: "head",
                icon: <i className="fas fa-clock"></i>, 
                component: DateSelect
            },
            // "auto-created-accounts" :  {
            //     title: "Autocreated Users",
            //     component: AutoCreatedUsersForm,
            //     group: "Events setting",
            //     undergroup: "Users management",
            //     position: "right"
            // },
            ...addedData
        }  

        // console.log( land?.invite_type  )
        if([INVITE_TYPE.MAY_BE, INVITE_TYPE.ONLY].includes(land?.invite_type || INVITE_TYPE.NONE)) {
            data["invite_request"] = {
                title: "User requests", 
                group: "Events setting",   
                position: "right",
                data_type: "LandUserInvite", 
                icon: <i className="fas fa-envelope"></i>, 
            }
        }
        setData(data)
    }, [ lands, land, eventTypeAdminData ])
    return data
} 